import React, { ReactElement } from "react";

function IconWrite({
  fill = "currentColor",
  size = 36,
}: {
  fill?: string;
  size?: number;
}): ReactElement {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0899 16.7314H12.0899C12.0899 16.7923 12.0403 16.8419 11.9793 16.8419H1.41919C1.35819 16.8419 1.3086 16.7923 1.3086 16.7314V1.26868C1.3086 1.20768 1.35819 1.15809 1.41919 1.15809H11.9793C12.0403 1.15809 12.0899 1.20768 12.0899 1.26868V2.34592L13.247 1.22934C13.2261 0.547957 12.6657 0 11.9793 0H1.41919C0.719652 0 0.150513 0.5691 0.150513 1.26868V16.7314C0.150513 17.4309 0.719612 18 1.41915 18H11.9793C12.6788 18 13.2479 17.4309 13.2479 16.7314V11.2882L12.0899 12.4463V16.7314Z"
        fill={fill}
      />
      <path
        d="M2.17407 13.5784C2.17407 13.8982 2.43333 14.1575 2.75311 14.1575H4.77811C4.56274 13.8147 4.4733 13.4067 4.52973 12.9994H2.75311V12.9994C2.43333 12.9994 2.17407 13.2586 2.17407 13.5784Z"
        fill={fill}
      />
      <path
        d="M5.15358 10.0933H2.75312C2.43333 10.0933 2.17407 10.3525 2.17407 10.6723C2.17407 10.9921 2.43333 11.2514 2.75312 11.2514H4.90269L5.15358 10.0933Z"
        fill="#6F6F6F"
      />
      <path
        d="M7.24865 7.18723H2.75312C2.43333 7.18723 2.17407 7.44649 2.17407 7.76627C2.17407 8.08605 2.43333 8.34531 2.75312 8.34531H6.09057L7.24865 7.18723Z"
        fill={fill}
      />
      <path
        d="M10.1547 4.28116H2.75312C2.43333 4.28116 2.17407 4.54042 2.17407 4.8602C2.17407 5.17998 2.43333 5.43924 2.75312 5.43924H8.99663L10.1547 4.28116Z"
        fill={fill}
      />
      <path
        d="M17.1666 2.36993C16.2186 1.39388 14.6751 1.39852 13.7295 2.34411C13.1959 2.8778 6.85479 9.21885 6.55804 9.51564C6.48152 9.59212 6.42541 9.69249 6.40155 9.80249L5.68437 13.1133C5.6433 13.3028 5.69966 13.5041 5.84086 13.6453C5.98112 13.7856 6.18206 13.8431 6.3729 13.8018L9.68367 13.0846C9.79261 13.061 9.89534 13.0034 9.97052 12.9281L17.142 5.75658C18.0821 4.81657 18.0805 3.31045 17.1666 2.36993ZM7.00657 12.4796L7.30863 11.0851L8.401 12.1775L7.00657 12.4796ZM16.3231 4.9377L9.56106 11.6998L7.78636 9.92503L14.5484 3.16296C15.0543 2.65705 15.8818 2.67387 16.3663 3.20831C16.8109 3.69818 16.801 4.45985 16.3231 4.9377Z"
        fill={fill}
      />
    </svg>
  );
}

export default IconWrite;
